import { render, staticRenderFns } from "./ChooseFromProspect.vue?vue&type=template&id=6e4b1486&scoped=true&"
import script from "./ChooseFromProspect.vue?vue&type=script&lang=js&"
export * from "./ChooseFromProspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4b1486",
  null
  
)

export default component.exports